<template>
    <div v-if="this.comp && visible">
        <div class="component-info">
        </div>
        <div class="helper-layer" id="helperLayer" ref="helperlayer">    
            <div class="notification" :class="customNotificationClass" ref="notif">
                <button class="delete" @click="closeHelp()"></button>
                {{texto}}
            </div>
        </div>
    </div>
</template>

<script>
    import quiniMixin from '@/mixins/quiniMixin'
    
    export default {
		mixins: [quiniMixin],
        props: {
            comp: {
                type: Object,
                required: false
            },
            id: {
                type: String,
                required: true
            },
            texto: {
                type: String,
                default: ''
            },
            cookie: {
                type: Boolean,
                default: true
            },
            scrollDownOnShow:{
                type: Boolean,
                default: true
            },
            customNotificationClass: {
                type: String,
                default: ''
            }
        },
        name: 'AyudaVisual',
        data() {
            return { 
                visible: true,
                resizeObserver: null,
                helperLayer: null
            }
        },
        methods: {
            locateHelp(){
                if (this.cookie && this.getCookie('ver-quiniela-' + this.id)) {
                    this.closeHelp()
                }else{
                    let left = this.comp.$el.offsetLeft
                    let width = this.comp.$el.offsetWidth
                    let height = this.comp.$el.offsetHeight
    
                    this.$refs.helperlayer.style.top = this.comp.$el.offsetTop + 'px'
                    this.$refs.helperlayer.style.left = (left) + 'px'
                    this.$refs.helperlayer.style.height = height + 'px'
                    this.$refs.helperlayer.style.width = width + 'px'
                    this.comp.$el.style.zIndex = 29;

                    if (this.scrollDownOnShow) {
                        window.scrollTo(0,1000)
                    }

                    this.listenToComp()
                }
            },
            closeHelp(){
                this.comp.$el.style.zIndex = 'auto';
                this.visible = false

                if (this.resizeObserver != null) {
                    this.resizeObserver.unobserve(this.comp.$el)
                    this.resizeObserver.disconnect()
                }
                if (this.cookie) {
                    this.setCookie('ver-quiniela-' + this.id, true, 7)
                }else{
                    this.$emit('close')
                }
            },
            listenToComp(){
                this.helperLayer = document.querySelector('#helperLayer')
                this.resizeObserver = new ResizeObserver(entries => {
                    this.helperLayer.style.left = entries[0].target.offsetLeft + 'px'
                    this.helperLayer.style.top = entries[0].target.offsetTop + 'px'
                    this.helperLayer.style.width = entries[0].target.offsetWidth + 'px'
                    this.helperLayer.style.height = entries[0].target.offsetHeight + 'px'
                });

                this.resizeObserver.observe(this.comp.$el)
            }
        },
        mounted() {
            if (this.comp != undefined) {
                this.locateHelp()
            }
        },
        updated(){
            if (this.$refs.notif != undefined) {
                this.locateHelp()
            }
        },
        destroyed() {
            
        }
    }
</script>

<style lang="css" scoped>
.component-info{
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 28;
    background: -webkit-gradient(radial,center center,0px,center center,100%,color-stop(0%,rgba(0,0,0,0.4)),color-stop(100%,rgba(0,0,0,0.9)));
	background: -webkit-radial-gradient(center,ellipse cover,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
    transition: all .3s ease-out;
}
.notification{
	position: absolute;
    bottom: 101%;
    left: 0;
    z-index: 28;
    max-height: 136px;
    text-overflow: ellipsis;
    margin-bottom: 12px;
}
.notification::after {
	content: '';
    position: absolute;
    left: 42%;
    top: 99%;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid white;
    clear: both;
    z-index: 28;
}
.helper-layer{
    position: absolute;
    background-color: transparent;
    box-shadow: 0 2px 15px rgba(0,0,0,.4);
    /* box-sizing: content-box; */
    z-index: 28;
}
 /* and (max-width: 1024px) */
@media (min-width: 768px) and (max-width: 1024px) { /* Tablet */
    .quiniela-top{
        bottom: -130% !important;
        margin-bottom: 0;
    }
    .quiniela-top::after {
        left: 42%;
        top: -4%;
        border-bottom: 7px solid white;
        border-top: 0;
    }
}
</style>